import keyBy from 'lodash/keyBy'

import {
  ADD_USERS,
  ADD_USER,
  CHANGE_USERS_APPROVE_STATUS_SUCCEEDED
} from '../constants';

const INITIAL_STATE = {
  byId: {},
  isInitialized: false
};

export default function customers(state = INITIAL_STATE, action) {
  const { type, payload } = action;

  switch (type) {

  case ADD_USERS: {
    return {...state, byId: keyBy(payload.users,'_id'), isInitialized: true}
  }
  case ADD_USER: {
    const {user} = payload;
    return {...state, byId: {...state.byId, [user._id]: user} };
  }
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js